
import React from 'react';

const RequiredIcon = () => (
    <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.35055 5.29885L2.39638 3.74172L0.769531 3.23043L1.14138 2.06839L2.79148 2.74237L2.69851 0.976074H4.1162L4.02324 2.74237L5.67333 2.06839L6.02194 3.23043L4.41833 3.74172L5.46416 5.29885L4.44157 5.99607L3.41898 4.34598L2.37314 5.99607L1.35055 5.29885Z" fill="#EB4335" />
    </svg>

);

export default RequiredIcon;